

// // #################################################

// import React, { useState, useMemo } from "react";
// import {
//   Select,
//   MenuItem,
//   Checkbox,
//   Avatar,
//   Box,
//   Typography,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
// import SearchIcon from "@mui/icons-material/Search";
// import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// const ProfileDropdown = ({ currentData = [], selectedProfiles = [], setSelectedProfiles }) => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // 🟢 Handle dropdown selection changes
// const handleDropdownChange = (event) => {
//   const rawValue = event?.target?.value;

//   // 🧹 Always coerce to array
//   let newValue = Array.isArray(rawValue)
//     ? rawValue
//     : typeof rawValue === "string"
//     ? rawValue.split(",")
//     : [];

//   // 🧹 Clean out undefined/null/empty
//   newValue = newValue.filter((v) => v && v !== "");

//   // // Ignore spurious clicks inside the search field
//   // if (newValue.length === 0 && selectedProfiles.length > 0) {
//   //   console.log("Ignored empty event triggered by pointer focus");
//   //   return;
//   // }

//   console.log("Incoming newValue:", newValue);

//   // 🧠 Toggle “All Profiles”
//   if (newValue.includes("all")) {
//     const shouldSelectAll = selectedProfiles.length !== currentData.length;
//     const updated = shouldSelectAll ? currentData.map((p) => p.profileId) : [];
//     console.log("Toggling all profiles:", shouldSelectAll, updated);
//     setSelectedProfiles(updated);
//     return;
//   }

//   // 🧠 Regular case: store cleaned list
//   const cleaned = newValue.filter((v) => v !== "all");

//   console.log("Selected profiles:", cleaned);
//   console.log("Selected profile count:", cleaned.length, "/", currentData.length);

//   setSelectedProfiles(cleaned);
// };



//   // 🟢 Platform icon renderer
//   const getPlatformIcon = (platform) => {
//     if (!platform) return null;
//     const name = platform.toLowerCase();
//     const iconStyle = { fontSize: 18, flexShrink: 0 };
//     switch (name) {
//       case "facebook":
//         return <FacebookRoundedIcon sx={{ ...iconStyle, color: "#282828" }} />;
//       case "youtube":
//         return <YouTubeIcon sx={{ ...iconStyle, color: "#282828" }} />;
//       case "instagram":
//         return <InstagramIcon sx={{ ...iconStyle, color: "#282828" }} />;
//       default:
//         return null;
//     }
//   };

//   // 🟢 Filter profiles based on search term
//   const filteredData = useMemo(() => {
//     return currentData.filter((p) =>
//       p.label.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [searchTerm, currentData]);

//   // 🟢 Render selected label in dropdown input
//   const renderSelectedValue = (selected) => {
//     if (selected.length === currentData.length) return "All Profiles";
//     if (selected.length === 0) return "Select Profiles";
//     return selected
//       .map((id) => currentData.find((p) => p.profileId === id)?.label)
//       .filter(Boolean)
//       .join(", ");
//   };

//   return (
//     <MDBox>
//       <MDTypography
//         variant="button"
//         fontWeight="medium"
//         color="text"
//         sx={{ marginBottom: 1, display: "block" }}
//       >
//         Filter Profiles
//       </MDTypography>

//       <Select
//         multiple
//         value={selectedProfiles}
//         onChange={handleDropdownChange}
//         displayEmpty
//         renderValue={renderSelectedValue}
//         onOpen={() => setIsDropdownOpen(true)}
//         onClose={() => {
//           setIsDropdownOpen(false);
//           setSearchTerm(""); // Reset search on close
//         }}
//         MenuProps={{
//           autoFocus: false,
//           disableAutoFocusItem: true,
//           PaperProps: {
//             sx: {
//               maxHeight: 400,
//               width: 280,
//               paddingTop: "4px",
//             },
//           },
//         }}
//         sx={{
//           minWidth: 220,
//           height: 48,
//           backgroundColor: "grey.100",
//           borderRadius: "12px",
//           border: "1px solid #ddd",
//           boxShadow: 1,
//           fontSize: "0.9rem",
//           fontWeight: 500,
//           paddingRight: "40px !important",
//           "&.Mui-focused": {
//             borderColor: "#00A1A1",
//             boxShadow: "0 0 0 2px rgba(0,161,161,0.2)",
//           },
//           "&:hover": { backgroundColor: "grey.200" },
//           "& .MuiSelect-select": {
//             display: "flex",
//             alignItems: "center",
//             padding: "8px 12px",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           },
//         }}
//         IconComponent={() => (
//           <ExpandMoreRoundedIcon
//             sx={{
//               position: "absolute",
//               right: 10,
//               top: "50%",
//               transform: `translateY(-50%) rotate(${isDropdownOpen ? 180 : 0}deg)`,
//               transition: "transform 0.3s ease",
//               fontSize: "28px !important",
//               color: "#444",
//               opacity: 0.8,
//               pointerEvents: "none",
//             }}
//           />
//         )}
//       >
//         {/* 🔍 Search Bar */}
//         <MenuItem disableRipple disableGutters sx={{ padding: "6px 12px" }}>
//           <TextField
//             variant="outlined"
//             placeholder="Search profiles..."
//             size="small"
//             fullWidth
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             onKeyDown={(e) => e.stopPropagation()} // prevents unwanted toggle
//             autoFocus
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: "grey.600", fontSize: 18 }} />
//                 </InputAdornment>
//               ),
//               sx: {
//                 borderRadius: "8px",
//                 fontSize: "0.85rem",
//                 backgroundColor: "grey.100",
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "grey.300",
//                 },
//                 "&:hover .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#00A1A1",
//                 },
//                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#00A1A1",
//                 },
//               },
//             }}
//           />
//         </MenuItem>

//         {/* 👥 All Profiles */}
//         <MenuItem
//           value="all"
//           sx={{
//             fontSize: "14px",
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             padding: "6px 12px",
//             borderRadius: "8px",
//             margin: "3px 6px",
//             transition: "all 0.2s ease-in-out",
//             backgroundColor:
//               selectedProfiles.length === currentData.length ? "grey.300" : "transparent",
//             "&:hover": { backgroundColor: "grey.200" },
//           }}
//         >
//           <Checkbox
//             checked={selectedProfiles.length === currentData.length}
//             indeterminate={
//               selectedProfiles.length > 0 &&
//               selectedProfiles.length < currentData.length
//             }
//             sx={{ padding: "4px", color: "#00A1A1" }}
//           />
//           <Avatar
//             sx={{
//               width: 22,
//               height: 22,
//               backgroundColor: "#00A1A1",
//               fontSize: "0.8rem",
//               color: "#fff",
//             }}
//           >
//             👥
//           </Avatar>
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: "0.9rem",
//               color: "black",
//               fontWeight: "bold",
//               marginLeft: 1,
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             All Profiles
//           </Typography>
//         </MenuItem>

//         {/* Individual Profiles (filtered) */}
//         {filteredData.map((profile) => {
//           const isSelected = selectedProfiles.includes(profile.profileId);
//           return (
//             <MenuItem
//               key={profile.profileId}
//               value={profile.profileId}
//               sx={{
//                 fontSize: "14px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 padding: "6px 12px",
//                 borderRadius: "8px",
//                 margin: "3px 6px",
//                 transition: "all 0.2s ease-in-out",
//                 backgroundColor: isSelected ? "grey.300" : "transparent",
//                 "&:hover": { backgroundColor: "grey.200" },
//               }}
//             >
//               <Checkbox checked={isSelected} sx={{ padding: "4px", color: "#00A1A1" }} />
//               <Avatar
//                 src={profile.profilePictureUrl}
//                 alt={profile.label}
//                 sx={{ width: 22, height: 22, flexShrink: 0 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 0.75,
//                   flex: 1,
//                   overflow: "hidden",
//                   minWidth: 0,
//                 }}
//               >
//                 {getPlatformIcon(profile.platform)}
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontSize: "0.9rem",
//                     color: "black",
//                     fontWeight: isSelected ? 600 : 400,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {profile.label}
//                 </Typography>
//               </Box>
//             </MenuItem>
//           );
//         })}
//       </Select>
//     </MDBox>
//   );
// };

// export default ProfileDropdown;

// ###############################################

import React, { useState, useMemo } from "react";
import {
  Select,
  MenuItem,
  Checkbox,
  Avatar,
  Box,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import SearchIcon from "@mui/icons-material/Search";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const ProfileDropdown = ({ currentData = [], selectedProfiles = [], setSelectedProfiles }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // 🟢 Handle dropdown selection changes
  const handleDropdownChange = (event) => {
    const rawValue = event?.target?.value;

    // 🧹 Always coerce to array
    let newValue = Array.isArray(rawValue)
      ? rawValue
      : typeof rawValue === "string"
      ? rawValue.split(",")
      : [];

    // 🧹 Clean out undefined/null/empty
    newValue = newValue.filter((v) => v && v !== "");

    console.log("Incoming newValue:", newValue);

    // 🧠 Toggle “All Profiles”
    if (newValue.includes("all")) {
      const shouldSelectAll = selectedProfiles.length !== currentData.length;
      const updated = shouldSelectAll ? currentData.map((p) => p.profileId) : [];
      console.log("Toggling all profiles:", shouldSelectAll, updated);
      setSelectedProfiles(updated);
      return;
    }

    // 🧠 Regular case: store cleaned list
    const cleaned = newValue.filter((v) => v !== "all");

    console.log("Selected profiles:", cleaned);
    console.log("Selected profile count:", cleaned.length, "/", currentData.length);

    setSelectedProfiles(cleaned);
  };

  // 🟢 Platform icon renderer
  const getPlatformIcon = (platform) => {
    if (!platform) return null;
    const name = platform.toLowerCase();
    const iconStyle = { fontSize: 18, flexShrink: 0 };
    switch (name) {
      case "facebook":
        return <FacebookRoundedIcon sx={{ ...iconStyle, color: "#282828" }} />;
      case "youtube":
        return <YouTubeIcon sx={{ ...iconStyle, color: "#282828" }} />;
      case "instagram":
        return <InstagramIcon sx={{ ...iconStyle, color: "#282828" }} />;
      default:
        return null;
    }
  };

  // 🟢 Filter profiles based on search term
  const filteredData = useMemo(() => {
    return currentData.filter((p) =>
      p.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, currentData]);

  // 🟢 Render selected label in dropdown input
  const renderSelectedValue = (selected) => {
    if (selected.length === currentData.length) return "All Profiles";
    if (selected.length === 0) return "Select Profiles";
    return selected
      .map((id) => currentData.find((p) => p.profileId === id)?.label)
      .filter(Boolean)
      .join(", ");
  };

  return (
    <MDBox>
      <MDTypography
        variant="button"
        fontWeight="medium"
        color="text"
        sx={{ marginBottom: 1, display: "block", textAlign: "center", }}
      >
        Filter Profiles
      </MDTypography>
      <MDBox
        bgColor="#f7f7f7" // light grey background
        sx={{
          
          borderRadius: "16px",
          backgroundColor: "#f0f2f5",
          padding: "14px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
      <Select
        multiple
        value={selectedProfiles}
        onChange={handleDropdownChange}
        displayEmpty
        renderValue={(selected) => {
          const displayText = renderSelectedValue(selected);
          return (
            // <Box
            //   sx={{
            //     whiteSpace: "nowrap",
            //     overflow: "hidden",
            //     textOverflow: "ellipsis",
            //     maxWidth: "100%",
            //   }}
            //   title={displayText} // Tooltip for full list
            // >
            //   {displayText}
            // </Box>

            <MDTypography
              variant="button"
              fontWeight={"bold"}
              sx={{
                fontSize: "0.9rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
              title={displayText} // Tooltip for full list
            >
              {displayText}
            </MDTypography>
          );
        }}
        onOpen={() => setIsDropdownOpen(true)}
        onClose={() => {
          setIsDropdownOpen(false);
          setSearchTerm(""); // Reset search on close
        }}
        MenuProps={{
          autoFocus: false,
          disableAutoFocusItem: true,
          PaperProps: {
            sx: {
              maxHeight: 400,
              width: 280,
              paddingTop: "4px",
            },
          },
        }}
        sx={{
          minWidth: 220,
          maxWidth: 280, // ⬅️ Prevent width expansion
          height: 48,
          backgroundColor: "grey.100",
          borderRadius: "12px",
          border: "1px solid #ddd",
          boxShadow: 1,
          fontSize: "0.9rem",
          fontWeight: 500,
          paddingRight: "40px !important",
          "&.Mui-focused": {
            borderColor: "#00A1A1",
            boxShadow: "0 0 0 2px rgba(0,161,161,0.2)",
          },
          transition: "all 0.3s ease-in-out",
          "&:hover": { 
            // backgroundColor: "grey.200",
            transform: "translateY(-4px)",
            boxShadow: 4, 
          },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          },
        }}
        IconComponent={() => (
          <ExpandMoreRoundedIcon
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: `translateY(-50%) rotate(${isDropdownOpen ? 180 : 0}deg)`,
              transition: "transform 0.3s ease",
              fontSize: "28px !important",
              color: "#444",
              opacity: 0.8,
              pointerEvents: "none",
            }}
          />
        )}
      >
        
        {/* 🔍 Search Bar */}
        <MenuItem disableRipple disableGutters sx={{ padding: "6px 12px" }}>
          <TextField
            variant="outlined"
            placeholder="Search profiles..."
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()} // prevents unwanted toggle
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "grey.600", fontSize: 18 }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "8px",
                fontSize: "0.85rem",
                backgroundColor: "grey.100",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey.300",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00A1A1",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00A1A1",
                },
              },
            }}
          />
        </MenuItem>

        {/* 👥 All Profiles */}
        <MenuItem
          value="all"
          sx={{
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            gap: 1,
            padding: "6px 12px",
            borderRadius: "8px",
            margin: "3px 6px",
            transition: "all 0.2s ease-in-out",
            backgroundColor:
              selectedProfiles.length === currentData.length ? "grey.300" : "transparent",
            "&:hover": { backgroundColor: "grey.200" },
          }}
        >
          <Checkbox
            checked={selectedProfiles.length === currentData.length}
            indeterminate={
              selectedProfiles.length > 0 && selectedProfiles.length < currentData.length
            }
            sx={{ padding: "4px", color: "#00A1A1" }}
          />
          <Avatar
            sx={{
              width: 22,
              height: 22,
              backgroundColor: "#00A1A1",
              fontSize: "0.8rem",
              color: "#fff",
            }}
          >
            👥
          </Avatar>
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.9rem",
              color: "black",
              fontWeight: "bold",
              marginLeft: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            All Profiles
          </Typography>
        </MenuItem>

        {/* Individual Profiles (filtered) */}
        {filteredData.map((profile) => {
          const isSelected = selectedProfiles.includes(profile.profileId);
          return (
            <MenuItem
              key={profile.profileId}
              value={profile.profileId}
              sx={{
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: 1,
                padding: "6px 12px",
                borderRadius: "8px",
                margin: "3px 6px",
                transition: "all 0.2s ease-in-out",
                backgroundColor: isSelected ? "grey.300" : "transparent",
                "&:hover": { backgroundColor: "grey.200" },
              }}
            >
              <Checkbox checked={isSelected} sx={{ padding: "4px", color: "#00A1A1" }} />
              <Avatar
                src={profile.profilePictureUrl}
                alt={profile.label}
                sx={{ width: 22, height: 22, flexShrink: 0 }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  flex: 1,
                  overflow: "hidden",
                  minWidth: 0,
                }}
              >
                {getPlatformIcon(profile.platform)}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.9rem",
                    color: "black",
                    fontWeight: isSelected ? 600 : 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {profile.label}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Select>
      </MDBox>
    </MDBox>
  );
};

export default ProfileDropdown;
